<template>
    <div class="">
        
        <template>
            <the-header />
        </template>

        <div class="site-wrapper-reveal">
            <!--============ Resolutions Hero Start ============-->
            <div class="service-hero-wrapper resolutions-hero-space resolutions-hero-bg position-relative random" :style="{ backgroundImage: 'url(' + require('@/assets/images/banners/axis-realty-group-banner-' + randomIndex + '.jpg') + ')' }">
                <div class="banner-overlay"></div>
                <ul class="image-list">
                    <li v-if="randomIndex === 1"><img src="@/assets/images/banners/axis-realty-group-banner-1.jpg" alt="Axis Realty Group"/></li>
                    <li v-if="randomIndex === 2"><img src="@/assets/images/banners/axis-realty-group-banner-2.jpg" alt="Axis Realty Group"/></li>
                    <li v-if="randomIndex === 3"><img src="@/assets/images/banners/axis-realty-group-banner-3.jpg" alt="Axis Realty Group"/></li>
                    <li v-if="randomIndex === 4"><img src="@/assets/images/banners/axis-realty-group-banner-4.jpg" alt="Axis Realty Group"/></li>
                    <li v-if="randomIndex === 5"><img src="@/assets/images/banners/axis-realty-group-banner-5.jpg" alt="Axis Realty Group"/></li>
                    <li v-if="randomIndex === 6"><img src="@/assets/images/banners/axis-realty-group-banner-6.jpg" alt="Axis Realty Group"/></li>
                </ul>

                <div class="container">
                    <div class="row">
                        <div class="col-lg-12 col-md-12 ml-auto mr-auto">
                            <div class="service-hero-wrap wow move-up">
                                <div class="service-hero-text text-center">
                                    <h3 class="text-white">Axis Realty Group</h3>
                                    <p class="text-white">Proven 15 years’ track record in property management.</p>

                                    <div class="hero-button-group section-space--mt_50">
                                        <router-link to="./find-a-rental" class="vs-component vs-button bg-primary-gradient vs-button-primary vs-button-filled text-white mx-1 sm:mx-2">Find A Rental</router-link>
                                        <router-link to="./apply-for-rental" class="vs-component vs-button bg-primary-gradient vs-button-primary vs-button-filled text-white mx-1 sm:mx-2">Apply Online</router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="vc_row-separator center_curve_alt bottom">
                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" preserveAspectRatio="none" viewBox="0 0 100 100">
                        <path d="M 0 0 L0 100 L100 100 L100 0 Q 50 200 0 0"></path>
                    </svg>
                </div>
            </div>
            <!--============ Resolutions Hero End ============-->

            <div class="feature-images-wrapper bg-gray">
                <div class="container">

                    <div class="row">
                        <div class="col-12">
                            <div class="feature-images__five resolutions-hero-bottom">
                                <div class="row">

                                    <div class="col-lg-4 col-md-6 wow move-up">
                                        <!-- ht-box-icon Start -->
                                        <div class="ht-box-images style-05">
                                            <div class="image-box-wrap">
                                                <div class="box-image">
                                                    <div class="default-image">
                                                        <img class="img-fulid" src="@/assets/images/icons/marker.png" alt="">
                                                    </div>
                                                    <div class="hover-images">
                                                        <img class="img-fulid" src="@/assets/images/icons/marker.png" alt="">
                                                    </div>
                                                </div>
                                                <div class="content">
                                                    <h5 class="heading">Looking for a rental?</h5>
                                                    <div class="text">We’ll find you the perfect place to call home.</div>
                                                    <div class="box-images-arrow">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- ht-box-icon End -->
                                    </div>

                                    <div class="col-lg-4 col-md-6 wow move-up">
                                        <!-- ht-box-icon Start -->
                                        <div class="ht-box-images style-05">
                                            <div class="image-box-wrap">
                                                <div class="box-image">
                                                    <div class="default-image">
                                                        <img class="img-fulid" src="@/assets/images/icons/home.png" alt="">
                                                    </div>
                                                    <div class="hover-images">
                                                        <img class="img-fulid" src="@/assets/images/icons/home.png" alt="">
                                                    </div>
                                                </div>
                                                <div class="content">
                                                    <h5 class="heading">Need Property management services?</h5>
                                                    <div class="text">We&#39;re highly experienced in providing property management services in St Louis.</div>
                                                    <div class="box-images-arrow">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- ht-box-icon End -->
                                    </div>

                                    <div class="col-lg-4 col-md-6 wow move-up">
                                        <!-- ht-box-icon Start -->
                                        <div class="ht-box-images style-05">
                                            <div class="image-box-wrap">
                                                <div class="box-image">
                                                    <div class="default-image">
                                                        <img class="img-fulid" src="@/assets/images/icons/key.png" alt="">
                                                    </div>
                                                    <div class="hover-images">
                                                        <img class="img-fulid" src="@/assets/images/icons/key.png" alt="">
                                                    </div>
                                                </div>
                                                <div class="content">
                                                    <h5 class="heading">Need Tenant Services?</h5>
                                                    <div class="text">We make it easier to pay your rent and submit maintenance requests.</div>
                                                    <div class="box-images-arrow">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- ht-box-icon End -->
                                    </div>

                                </div>
                            </div>

                            <div class="section-under-heading text-center section-space--mt_80"></div>

                        </div>
                    </div>
                </div>
            </div>

            <div class="our-company-history our-company-history-bg section-space--ptb_100">
                <div class="container-fluid">
                    <div class="grid-wrapper">
                        <div class="line line-1"></div>
                        <div class="line line-2"></div>
                        <div class="line line-3"></div>
                        <div class="line line-4"></div>
                    </div>

                    <div class="row align-items-center">
                        <div class="col-lg-6">
                            <!-- <div class="rv-video-section">
                                <div class="main-video-box video-popup">
                                    <a href="" class="video-link  mt-30">
                                        <div class="single-popup-wrap">
                                            <div class="ht-popup-video video-button">
                                                <div class="video-mark">
                                                    <div class="wave-pulse wave-pulse-1"></div>
                                                    <div class="wave-pulse wave-pulse-2"></div>
                                                </div>
                                                <div class="video-button__two">
                                                    <div class="video-play">
                                                        <span class="video-play-icon"></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </div> -->
                        </div>
                        <div class="col-lg-6">
                            <div class="faq-custom-col">
                                <div class="section-title-wrap text-white">
                                    <h3 class="heading text-white">Why choose us?</h3>

                                    <p class="text mt-30">Property management is a tough juggling act that requires expertise in tenant verification, property
                                        listing and showing, legal knowledge, among many other roles. Axis Realty takes care of these highly
                                        involving tasks while you enjoy returns on your investment.</p>
                                    
                                    <h6 class="heading text-white">What makes us different?</h6>
                                    <ul class="infotechno-blog-list text-white mt-8">
                                        <li class="list-item"><a href="javascript:void(0);">Proven 15 years’ track record in property management.</a></li>
                                        <li class="list-item"><a href="javascript:void(0);">You enjoy lower service charges and a higher ROI partnering with us.</a></li>
                                        <li class="list-item"><a href="javascript:void(0);">We use the latest technology to deliver services while still maintaining a personal touch.</a></li>
                                        <li class="list-item"><a href="javascript:void(0);">We offer diversified property management services so you can pick the type of service you prefer.</a></li>
                                        <li class="list-item"><a href="javascript:void(0);">We don’t outsource crucial property management jobs, meaning closer control, faster service delivery, and lower management fees.</a></li>
                                        <li class="list-item"><a href="javascript:void(0);">We&#39;re always up to date with the latest trends in the real estate market in St. Louis.</a></li>
                                    </ul>

                                    <p class="mt-4">Let us handle the headaches while you enjoy returns on your property investment.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="projects-wrapper projectinfotechno-bg section-space--ptb_100">
                <div class="container">

                    <div class="row">
                        <div class="col-lg-12">
                            <!-- section-title-wrap Start -->
                            <div class="section-title-wrap text-center section-space--mb_40">
                                <h6 class="section-sub-title mb-4">Looking for a place to rent?</h6>
                                <h3 class="heading">Select from our broad range of quality and affordable rentals.</h3>
                            </div>
                            <!-- section-title-wrap Start -->
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            <div class="projects-wrap swiper-container projects-slider__container">
                                <swiper :options="swiperOption" :dir="$vs.rtl ? 'rtl' : 'ltr'" :key="$vs.rtl">
                                    <swiper-slide v-for="(property, index) in propertiesResponse.properties" :key="index">
                                        <router-link :to="`${baseUrl}/home-for-rent/${property.id}`" class="projects-wrap style-01 wow move-up">
                                            <div class="projects-image-box">
                                                <div class="projects-image text-center">
                                                    <img class="img-fluid img-height" :src="property.images[0]" alt="">
                                                </div>
                                                <div class="content">
                                                    <h6 class="heading info">{{property.address}}</h6>
                                                    <h6 class="heading address">$ {{property.rent}} | {{property.property_type}} | {{property.bathrooms}} baths</h6>
                                                    <div class="box-projects-arrow">
                                                        <span class="button-text">View</span>
                                                        <feather-icon icon="ArrowRightIcon" svgClasses="h-4 w-4" class="ml-2 align-middle" />
                                                    </div>
                                                </div>
                                            </div>
                                        </router-link>
                                    </swiper-slide>
                                    <div class="swiper-pagination swiper-pagination-project mt_20" slot="pagination"></div>
                                </swiper>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
            
        <the-footer />
    </div>
</template>

<script>
// import 'swiper/dist/css/swiper.min.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import TheHeader   from '@/layouts/components/TheHeader.vue'
import TheFooter   from '@/layouts/components/TheFooter.vue'
import UserProperty from '@/js/userProperty.js'

export default {
  components: {
    TheHeader,
    TheFooter,
    swiper,
    swiperSlide
  },
  data () {
    return {
      propertiesResponse: {},
      swiperOption: {
        slidesPerView: 3,
        spaceBetween: 0,
        // init: false,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        breakpoints: {
          1024: {
            slidesPerView: 1,
            spaceBetween: 40
          },
          768: {
            slidesPerView: 1,
            spaceBetween: 30
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 20
          }
        }
      },
      randomIndex: Number(Math.floor(Math.random() * 6)) + 1
    }
  },
  methods: {
    setFullVacantProperties (propertiesResponse) {
      this.propertiesResponse = propertiesResponse
    }
  },
  created () {
    UserProperty.getFullVacantProperties(this)
  },
  computed: {
    baseUrl () {
      const path = this.$route.path
      return path.slice(0, ('/'))
    }
  }
}
</script>